import { isDashboardV2Enabled, isPathToGoDefaultTabEnabled } from '../lib/runtimeFlags';

export const CONFIG = {
  UI: {
    DASHBOARD_V2: isDashboardV2Enabled(),
    // RETIRED (Path to GO removal, stage 2): off everywhere, read by nothing.
    // Kept until the flag's deploy plumbing is removed (see
    // isPathToGoDefaultTabEnabled).
    PATH_TO_GO_DEFAULT: isPathToGoDefaultTabEnabled(),
  },
} as const;
